export default [
  {
    key: 'personal-information',
    title: 'common.profileSection.personalInformation',
    icon: 'account_circle',
  },
  {
    key: 'email-alias',
    title: 'common.profileSection.emailAlias',
    icon: 'mail',
  },
  {
    key: 'password',
    title: 'common.profileSection.password',
    icon: 'key',
  },
  {
    key: 'identity-checking',
    title: 'common.profileSection.identityChecking',
    icon: 'id_card',
  },
  {
    key: 'settings',
    title: 'common.profileSection.settings',
    icon: 'settings',
  },
]
